import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: 'horizontal-form-field',
  templateUrl: './horizontal-form-field.component.html',
})
export class HorizontalFormFieldWrapperComponent extends FieldWrapper {
}
